var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNotFound = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M75.3036 91.5C73.5901 91.5 71.9026 91.9194 70.3884 92.7215L29.2937 114.491H71.1602C73.0932 114.491 74.6602 116.058 74.6602 117.991V132.106C74.6602 132.382 74.884 132.606 75.1602 132.606H99.9983V135.606H75.1602C73.2272 135.606 71.6602 134.039 71.6602 132.106V117.991C71.6602 117.715 71.4363 117.491 71.1602 117.491H22V114.491H22.8851L68.984 90.0705C70.9308 89.0392 73.1005 88.5 75.3036 88.5H99.9982V91.5H75.3036ZM23.5 154.004V125.443H20.5V154.004C20.5 161.46 26.5442 167.504 34 167.504H99.9983V164.504H34C28.201 164.504 23.5 159.803 23.5 154.004ZM174.235 117.295C177.435 119.764 179.497 123.637 179.497 127.991V154.004C179.497 161.46 173.452 167.504 165.997 167.504H99.9983V164.504H165.997C171.796 164.504 176.497 159.803 176.497 154.004V127.991C176.497 122.192 171.796 117.491 165.997 117.491H128.836C128.56 117.491 128.336 117.715 128.336 117.991V132.106C128.336 134.039 126.769 135.606 124.836 135.606H99.9983V132.606H124.836C125.113 132.606 125.336 132.382 125.336 132.106V117.991C125.336 116.058 126.903 114.491 128.836 114.491H164.047L128.869 93.0358C127.222 92.0314 125.331 91.5 123.402 91.5H99.9983V88.5H123.402C125.882 88.5 128.314 89.1832 130.431 90.4746L174.281 117.219L174.235 117.295Z",
    fill: "#1B1B1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100 78V32",
    stroke: "#59BD39",
    strokeWidth: 3
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.686 76.3135L139.314 53.6861",
    stroke: "#59BD39",
    strokeWidth: 3
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6863 53.6865L83.3137 76.3139",
    stroke: "#59BD39",
    strokeWidth: 3
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNotFound);
export default ForwardRef;